import { useCallback } from "react";
import axios from "../../api/axiosInstance";
import { isAffectingNextWorkingDay, getClosestWorkingDay  } from "../../utils/dateHelpers";
import showModal from "../../components/ui/modals/showModal";
import { formatDateList } from "../../utils/formatDateList";

function useBulkCancelReservations({
  selectedDates,
  userReservations,
  baseUrl,
  refetchUserReservations,
  refetchNextReservationInfo,
  lightReset,
  setSelectedDates
}) {
  const cancelSelectedReservations = useCallback(async () => {
    if (selectedDates.length === 0) {
      showModal("Nie wybrano żadnych dat.", {type: "error"});
      return;
    }
    const selectedDateStrings = selectedDates.map(d =>
      d.toISOString().split("T")[0]
    );
    const reservationsToDelete = userReservations.filter(r =>
      selectedDateStrings.includes(r.date)
    );

    if (reservationsToDelete.length === 0) {
      showModal("Nie masz rezerwacji na wybrane dni.", {type:"info"});
      return;
    }

    const readable = formatDateList(reservationsToDelete.map(r => r.date));

    const confirm = await showModal(
      `Czy na pewno chcesz usunąć rezerwacje z następujących dni?\n\n${readable}`, {type: "confirm"}
    );

    if (!confirm) return;
    
    const token = localStorage.getItem("token");

    try {
      await axios.delete(`${baseUrl}/api/reservations/bulk`, {
        data: { ids: reservationsToDelete.map(r => r.id) }
      });

      showModal("✅ Rezerwacje zostały usunięte.", {type: "success"});
      refetchUserReservations();

      if (isAffectingNextWorkingDay(selectedDates)) {
        refetchNextReservationInfo();
      }

      const fallbackDate = getClosestWorkingDay(new Date());
      setSelectedDates([fallbackDate]);
      lightReset?.();
    } catch (err) {
      console.error(err);
      showModal("❌ Wystąpił błąd podczas usuwania rezerwacji.", {type: "error"});
    }
  }, [
    selectedDates,
    userReservations,
    baseUrl,
    refetchUserReservations,
    refetchNextReservationInfo,
    lightReset,
    setSelectedDates
  ]);

  return cancelSelectedReservations;
}

export default useBulkCancelReservations;
